export enum ActivationType {
  VOUCHER = "ActivationVoucher",
  LINK = "Link",
  PHONE = "PhoneNumber",
  PASSIVE_MAILS = "PassiveMails"
}
